{
  "theme.switch": "Change theme",
  "theme.light": "Light",
  "theme.dark": "Dark",
  "theme.system": "System",
  "user.role.admin": "Administrator",
  "user.role.viewer": "Read only",
  "user.role.scopeAll": "All tickets",
  "user.supportAgent": "Support agent",
  "user.openMenu": "Open user menu",
  "user.profile": "Profile",
  "user.accountSettings": "Account settings",
  "user.signingOut": "Signing out…",
  "user.signOut": "Sign out",
  "user.signOutFailed": "Unable to sign out. Please try again.",
  "version.ready": "A new version is ready",
  "version.description": "The app has been updated. Refresh the page to avoid unexpected behavior.",
  "version.refresh": "Refresh now",
  "auth.reload": "Reload",
  "auth.relogin": "Sign in again",
  "auth.callback.title": "Completing sign-in",
  "auth.callback.detail": "Authentication is complete. Opening Tickbird.",
  "auth.restore.title": "Restoring your session",
  "auth.restore.detail": "Securely connecting to the identity service. Please wait.",
  "auth.redirect.title": "Redirecting to sign in",
  "auth.redirect.detail": "Redirecting to your organization's identity service.",
  "auth.error.title": "Sign-in was not completed",
  "auth.error.detail": "Check the IAM client, callback URL, and browser network connection, then try again.",
  "auth.firstStart": "First-time setup",
  "auth.missingConfig.title": "IAM configuration is required",
  "auth.missingConfig.copy": "Copy",
  "auth.missingConfig.as": "to",
  "auth.missingConfig.finish": ", enter the OIDC Authority and Client ID, then restart the development server. The SPA uses Authorization Code + PKCE and does not require a client secret.",
  "auth.session.loadingTitle": "Preparing your workspace",
  "auth.session.loadingDetail": "Loading your account and permissions.",
  "auth.sessionExpired.title": "Your session has expired",
  "auth.sessionExpired.detail": "Sign in again to continue loading or submitting data. You can stay on this page for now. Copy any unsaved content before signing in again.",
  "auth.sessionExpired.reminder": "Sign in again to continue. Copy any unsaved content before leaving this page.",
  "auth.sessionExpired.dismiss": "Not now",
  "auth.sessionExpired.signIn": "Sign in again",
  "auth.sessionExpired.signingIn": "Redirecting to sign in…",
  "auth.sessionExpired.failed": "Unable to start sign-in. Check your connection and try again.",
  "auth.admission.notProvisioned.title": "Your account has not been provisioned",
  "auth.admission.notProvisioned.detail": "Your identity is authenticated, but you have not been added to Tickbird. Ask an administrator to provision your account and assign a role under Teams & agents, then reload.",
  "auth.admission.noRoles.title": "No role has been assigned",
  "auth.admission.noRoles.detail": "Your account is active, but you do not belong to a support team and have no global role. Ask an administrator to add you to a team or assign a role under Teams & agents.",
  "auth.admission.inactive.title": "Account disabled",
  "auth.admission.inactive.detail": "Your Tickbird account has been disabled. Contact an administrator if this is unexpected.",
  "auth.admission.subjectMissing.title": "This token cannot access the workspace",
  "auth.admission.subjectMissing.detail": "The current token does not identify a person, such as a machine-client token. Sign in with your employee account.",
  "auth.admission.failed.title": "Unable to load your session",
  "auth.admission.failed.detail": "Check your network and try again. If the problem persists, ask an administrator to check the service status.",
  "auth.permissionDenied.title": "Access denied",
  "auth.permissionDenied.detail": "You do not have permission to access this page. Contact an administrator if your role needs to be changed.",
  "route.loading": "Loading page…",
  "route.error.title": "Something went wrong",
  "route.error.statusDescription": "The page request failed ({status}).",
  "route.error.description": "This page could not be displayed. Reload and try again.",
  "route.error.reload": "Reload",
  "request.forbidden.title": "Access denied",
  "request.forbidden.description": "You do not have permission to access this content. Contact an administrator for access.",
  "request.notFound.title": "Content not found",
  "request.failed.title": "Unable to load",
  "request.failed.description": "The request failed. Please try again later.",
  "request.loading": "Loading…",
  "request.retry": "Try again",
  "request.empty": "No data",
  "loading.alt": "Loading",
  "select.loading": "Loading",
  "dataTable.empty": "No data",
  "dataTable.filter.loading": "Loading {label}",
  "dataTable.filter.searching": "Searching {label}",
  "dataTable.filter.clearLabel": "Clear {label} filter",
  "dataTable.filter.selected": "{count} selected",
  "dataTable.filter.search": "Search {label}…",
  "dataTable.filter.noMatches": "No matching options",
  "dataTable.filter.clear": "Clear filters",
  "dataTable.sort.trigger": "Sort",
  "dataTable.sort.title": "Sort rules",
  "dataTable.sort.description": "Rules are applied from top to bottom. Add up to {count} fields.",
  "dataTable.sort.ascending": "Ascending",
  "dataTable.sort.descending": "Descending",
  "dataTable.sort.remove": "Remove sort rule {index}",
  "dataTable.sort.empty": "No sort rules have been added",
  "dataTable.sort.add": "Add sort",
  "dataTable.sort.clear": "Clear",
  "dataTable.pagination.records": "records",
  "dataTable.pagination.label": "Pagination",
  "dataTable.pagination.total": "{count} {itemLabel} total",
  "dataTable.pagination.previous": "Previous page",
  "dataTable.pagination.next": "Next page",
  "dataTable.pagination.page": "Page {page}",
  "categorySelect.none": "Uncategorized",
  "categorySelect.label": "Category",
  "categorySelect.searchLabel": "Search categories",
  "categorySelect.searchPlaceholder": "Search categories…",
  "categorySelect.treeLabel": "Category tree",
  "categorySelect.expand": "Expand {name}",
  "categorySelect.collapse": "Collapse {name}",
  "categorySelect.noMatches": "No matching categories",
  "extendedInfo.value": "Value",
  "extendedInfo.raw": "Raw content",
  "extendedInfo.booleanTrue": "Yes",
  "extendedInfo.booleanFalse": "No",
  "extendedInfo.showAll": "Show all {count}",
  "extendedInfo.showLess": "Show less",
  "dataTable.scrollRegion": "Table content",
  "dataTable.pagination.rowsPerPage": "Rows per page"
}
